export default "__VITE_ASSET__D1ESnpNb__"